import type { NativeReportColumn } from '@/api/reports';

/**
 * Vertical budget (px) the caveat takes beneath a chart: one `text-xs` line
 * (16px) plus its `mt-1` (4px). `ChartRendererCore` subtracts exactly this
 * from the chart height when the note renders, so a tile whose chart sits in
 * a fixed-height slot stays the same height with or without the caveat
 * rather than overflowing into a scrollbar by one line.
 */
export const EARLIEST_RATE_NOTE_HEIGHT = 20;

/**
 * Whether any column's converted figures used the oldest stored exchange
 * rate for at least one amount — see `NativeReportColumn.converted_at_earliest_rate`.
 */
export function hasEarliestRateConversion(
  columns: readonly Pick<NativeReportColumn, 'converted_at_earliest_rate'>[]
): boolean {
  return columns.some(column => column.converted_at_earliest_rate === true);
}
